import { AbstractControl, FormArray, FormGroup, UntypedFormControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { Params } from "@angular/router";

dayjs.extend(customParseFormat);

export class Validators {
    public static alphaSpaceRegEx = /[a-zA-Z ]+/;
    public static alphaNumericRegEx = /[a-zA-Z0-9]+/;
    public static alphaNumericHyphenRegEx = /[a-zA-Z0-9-]+/;
    public static alphaNumericHyphenApostropheRegEx = /[a-zA-Z0-9\-'`]+/;
    public static alphaHyphenSpaceRegEx = /[a-zA-Z\- ]+/;
    public static alphaNumericSpecialCharRegEx = /[a-zA-Z0-9\-#/\\ ]+/;
    public static alphaNumericSafeCharsRegEx = /[a-zA-Z0-9\-_.+ ]+/;
    public static atLeastOneDigitAndChar = /(?=.*\d)(?=.*[a-zA-Z])/;

    public static dateValidator(control: UntypedFormControl): Params {
        const parsed = dayjs(control.value, "MM/DD/YYYY", true);
        return (parsed.isValid() && parsed.isAfter(dayjs().subtract(200, "years"))) || !control.value ? null : { date: "Invalid date" };
    }

    public static minDateValidator(min): ValidatorFn {
        return (formControl: AbstractControl): ValidationErrors | null => {
            const formattedValue = dayjs(formControl.value, "MM/DD/YYYY", true);
            return formattedValue.isValid() && formattedValue.isBefore(min.value) ? { minDate: min } : null;
        };
    }

    public static formControlIsInValid(form: FormGroup | undefined, formControlName: string): boolean {
        return form ? Validators.isFormControlInvalid(form.get(formControlName)) : false;
    }

    static isFormControlInvalid(control: AbstractControl | undefined): boolean {
        return (control?.touched || control?.dirty) && control?.invalid;
    }

    static updateCheckboxValue(fromArray: AbstractControl, index, event) {
        (fromArray as FormArray).at(index).patchValue(event.target.checked ? JSON.parse(event.target.value) : false);
    }
}
